import { Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ReactQuill from 'react-quill';
import makeStyles from '@mui/styles/makeStyles';
import { convertHtmlToDelta } from 'utils/quillUtils';
import { InsuranceSelectSubmissionForm } from 'modules/vendorOpportunity/insurance/types';

export const InsuranceCoverageRequirements = () => {
  const classes = useStyles();

  const { getValues, setValue } = useFormContext<InsuranceSelectSubmissionForm>();

  return (
    <Stack gap="1rem">
      <Stack>
        <Typography component="span" variant="body1">
          Coverage Requirements:
        </Typography>

        <ReactQuill
          className={classes.reactQuill}
          value={convertHtmlToDelta(getValues('coverageRequirements'))}
          placeholder="Physical Damage Insurance is required for the full replacement value of the financed equipment. Minimum liability coverage of $500,000. Coverage must remain active for the full term of the financing agreement."
          onChange={value => {
            setValue('coverageRequirements', value);
          }}
        />
      </Stack>

      <Stack>
        <Typography component="span" variant="body1">
          Certificate Requirements:
        </Typography>

        <ReactQuill
          className={classes.reactQuill}
          value={convertHtmlToDelta(getValues('certificateRequirements'))}
          placeholder="Certificate must list [Lender Name] as the loss payee. Must include the applicant's full legal name and address. Insurance carrier must be licensed in the applicant's state of residence."
          onChange={value => {
            setValue('certificateRequirements', value);
          }}
        />
      </Stack>

      <Stack>
        <Typography component="span" variant="body1">
          Other Instructions:
        </Typography>

        <ReactQuill
          className={classes.reactQuill}
          value={convertHtmlToDelta(getValues('otherInstructions'))}
          placeholder="Electronic signature is required to confirm the insurance coverage is valid and meets the lender’s requirements. Contact [Lender Contact Name / Email] if you have questions about the insurance policy."
          onChange={value => {
            setValue('otherInstructions', value);
          }}
        />
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles({
  reactQuill: {
    '& .ql-container': {
      minHeight: '80px',
    },
  },
});
